import * as React from 'react';
import { withTranslation } from 'react-i18next';
import Helmet from 'react-helmet';

class NotFound extends React.Component<any, any> {
    private _isUnmounted: boolean = false;

    constructor(props: any) {
        super(props);

        console.log(this.props);
    }

    componentDidMount() {
    }

    componentWillUnmount() {
        this._isUnmounted = true;
    }

    render() {
        const { t } = this.props;

        return (
            <div className="i-body">
                <Helmet>
                    <title>{"Not Found (#404)" + " | " + window.location.host.toUpperCase() + " - Медиа портал в TAS-IX"}</title>
                </Helmet>
                <div className="container login-page v-index">
                    <div className="wrapper">
                        <div className="box pb-20">
                            <h1 className="text-danger">Not Found (#404)</h1>

                            <div className="alert alert-danger">
                                {t("Страница не найдена")}.
                            </div>

                            <p>
                                The above error occurred while the Web server was processing your request.    </p>
                            <p>
                                Please contact us if you think this is a server error. Thank you.    </p>

                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation()(NotFound);